import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const ContactUsConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/contact-us-list",
    component: React.lazy(() => import("./contact-us-list")),
  },
];
